import React from 'react';

import './FormItem.css';

export const FormItem = ({
  label,
  type = 'number',
  value,
  options,
  onChange,
  error,
  suffix,
}) => {
  let input = (
    <input
      className="FormItemInputText"
      type={type}
      value={value}
      onChange={e => onChange(e.target.value)}
    />
  );
  if (type === 'radio') {
    input = options.map(v => {
      return (
        <>
          <input
            key={v}
            type="radio"
            value={v}
            onChange={() => onChange(v)}
            checked={v === value}
          />
          {v}
        </>
      );
    });
  }
  if (type === 'select') {
    input = (
      <select
        className="FormItemSelect"
        onChange={e => onChange(e.target.value)}
        value={value}
      >
        {options.map(o => (
          <option value={o.value} key={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    );
  }
  return (
    <div className="FormItem">
      <div className="FormItemInput">
        <label>{label}</label>
        {input}
        {suffix && <span className="suffix">{suffix}</span>}
      </div>
      {error && <div>{error}</div>}
    </div>
  );
};
